import { render, staticRenderFns } from "./WorkIconInfo.vue?vue&type=template&id=8e0a1510"
import script from "./WorkIconInfo.vue?vue&type=script&lang=js"
export * from "./WorkIconInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports